module.exports = __webpack_public_path__ + "static/media/ubertaxi.856fb7ff.jpeg";